import React from "react";
import AntdTable from "../../../components/common/AntdTable";
import { Card, Row, Col, Typography } from "antd";

const { Text } = Typography;

const TrialBalanceTable = ({ trialBalanceData = {}, totals = {} }) => {
  const columns = [
    {
      title: "ACCOUNT NAME",
      dataIndex: "accountName",
      width: 300,
    },
    {
      title: "DEBIT",
      dataIndex: "debit",
      align: "right",
      width: 150,
      render: (debit) =>
        debit ? `UGX ${debit?.toLocaleString()}` : "UGX 0",
    },
    {
      title: "CREDIT",
      dataIndex: "credit",
      align: "right",
      width: 150,
      render: (credit) =>
        credit ? `UGX ${credit?.toLocaleString()}` : "UGX 0",
    },
    {
      title: "BALANCE",
      dataIndex: "balance",
      align: "right",
      width: 150,
      render: (balance) =>
        balance !== undefined
          ? `UGX ${balance?.toLocaleString()}`
          : "UGX 0",
    },
  ];

  // Add totals row to the data
  const tableData = trialBalanceData?.trialBalance || [];
  const dataWithTotals = [
    ...tableData,
    {
      accountName: "TOTAL",
      debit: totals?.totalDebit || 0,
      credit: totals?.totalCredit || 0,
      balance: totals?.totalBalance || 0,
      key: "totals-row",
    },
  ];

  return (
    <div>
      <AntdTable
        columns={columns}
        pagination={false}
        data={dataWithTotals}
        rowClassName={(record) =>
          record.key === "totals-row" ? "trial-balance-totals-row" : ""
        }
      />
      {totals && (
        <Card
          size="small"
          style={{ marginTop: 16 }}
          bodyStyle={{ padding: "16px 24px" }}
        >
          <Row gutter={16} justify="space-between" align="middle">
            <Col>
              <Text strong style={{ fontSize: "16px" }}>
                Balanced:{" "}
                {totals.totalDebit === totals.totalCredit ? (
                  <Text style={{ color: "#52c41a", fontWeight: "bold" }}>Yes</Text>
                ) : (
                  <Text style={{ color: "#ff4d4f", fontWeight: "bold" }}>No</Text>
                )}
              </Text>
            </Col>
            <Col>
              <Row gutter={16}>
                <Col>
                  <Text strong>Total Debit: </Text>
                  <Text>UGX {(totals.totalDebit || 0).toLocaleString()}</Text>
                </Col>
                <Col>
                  <Text strong>Total Credit: </Text>
                  <Text>UGX {(totals.totalCredit || 0).toLocaleString()}</Text>
                </Col>
                {totals.totalBalance !== undefined && (
                  <Col>
                    <Text strong>Total Balance: </Text>
                    <Text>UGX {(totals.totalBalance || 0).toLocaleString()}</Text>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default TrialBalanceTable;

